import { handleAxiosResponse, api_base_url, axiosInstance } from '../services/common.services';
import { handleServiceRequest } from '../services/handleServiceRequest';
import AuthClientStore from "../components/auth/AuthClientStore";

interface LoginResponse {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
    [key: string]: any;
}

interface Role {
    roleID: string;
    [key: string]: any;
}

export const authService = {
    login,
    forgotPassword,
    setPassword,
    logout,
    refreshAccess,
    getInfo
};


function login(Email: string, Password: string): Promise<LoginResponse> {
    const url = `${api_base_url}/api/auth/login`;
    const data = {
        Email: Email,
        Password: Password,
        clientId: 'barreca.admin_client'
    };
    return axiosInstance
        .post(url, data)
        .then(handleAxiosResponse)
        .then((user: LoginResponse) => {
            return user;
        });
}

function forgotPassword(Email: string): Promise<any> {
    const url = `${api_base_url}/api/auth/forgot-password`;
    const data = {
        Email: Email,
    };
    return axiosInstance
        .post(url, data)
        .then(handleAxiosResponse)
        .then((user: any) => user);
}

function refreshAccess(token: string): Promise<any> {
    const url = `${api_base_url}/api/auth/refresh`;
    const data = {
        refreshToken: token,
        clientId: 'barreca.admin_client'
    };
    return axiosInstance
        .post(url, data)
        .then(handleAxiosResponse)
        .then((user: any) => user);
}

function setPassword(userId: string, resetCode: string, newPassword: string): Promise<any> {
    const url = `${api_base_url}/api/auth/reset-password`;
    const data = {
        userId: userId,
        resetCode: resetCode,
        newPassword: newPassword
    };
    return axiosInstance
        .post(url, data)
        .then(handleAxiosResponse)
        .then((user: any) => user);
}

function logout(): void {
    // remove user from local storage to log user out
    AuthClientStore.removeRefreshToken()
    AuthClientStore.removeRefreshToken()
    AuthClientStore.removeWebUniqueId()
}

function getInfo(handleAccessExpirationError): Promise<any> {
    const getObject = {
        url: '/api/account/info',
        customHandleError: handleAccessExpirationError
    };
    return handleServiceRequest.get(getObject).then((res: any) => {
        if (res) {
            localStorage.setItem('userInfo', JSON.stringify(res));
            const event = document.createEvent('Event');
            event.initEvent('storage', true, true);
            window.dispatchEvent(event);
        }
        return res;
    });
}
